import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconAttachmentSvg }  from '../../assets/icons/icon_attachment.svg';

const FileUploadIcon=(props)=>{
    return <Icon component={() => <IconAttachmentSvg />} {...props}/>
}

export default FileUploadIcon;